import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const getPrivileges = createApiThunk<Privilege[], void>({
  action: 'privileges',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_PRIVILEGES,
})
